/**
 * @larroude/shop-by-size
 *
 * Progressive enhancement da faixa "SHOP BY SIZE" (snippet
 * collection-shop-by-size.liquid). Renderiza chips de tamanho acima da grade
 * da coleção. Cada chip é, na origem, um link nativo (<a href> com os params
 * de filtro do Shopify) que funciona com reload — fallback garantido.
 *
 * APPROACH
 * Ao clicar num chip, em vez de recarregar a página, encontramos o checkbox
 * nativo correspondente do filtro de tamanho DENTRO de [data-filter-bar],
 * alternamos o estado e disparamos um evento 'change'. O pipeline de filtro do
 * próprio tema (changeHandler -> filterChange -> Section Rendering API +
 * pushState + patch de #root) faz todo o resto. Como a faixa vive dentro de
 * #root, ela é re-renderizada server-side a cada filtro/voltar, mantendo o
 * estado ativo dos chips sempre correto.
 *
 * PARAM POR LOJA (verificado no live 2026-07-27)
 * O nome do facet difere entre as lojas:
 *   US -> filter.v.option.size
 *   BR -> filter.v.option.tamanho
 * Por isso o param NAO e constante: e lido de data-sbs-param, publicado pelo
 * snippet a partir do param_name real do facet daquela colecao. Assim o mesmo
 * asset serve as duas lojas e sobrevive a uma renomeacao da opcao.
 *
 * SAFETY
 * - Não toca no bundle vendor (theme.js). Só dispara eventos que o tema já ouve.
 * - Delegação de clique em document => sobrevive a re-renders de #root e da barra.
 * - Se não houver checkbox nativo (facet de tamanho desabilitada ou show_filters
 *   off), NÃO chamamos preventDefault => o <a href> navega normalmente (reload).
 * - Só atua em inputs dentro de [data-filter-bar]; nunca no drawer/sidebar, pois
 *   o changeHandler do tema só reage a mudanças escopadas na barra.
 * - No-op silencioso em páginas sem [data-shop-by-size].
 */
(function () {
  'use strict';

  var FALLBACK_PARAM = 'filter.v.option.size';

  // Param do facet desta colecao, publicado pelo snippet no DOM.
  function paramFor(band) {
    if (!band) return FALLBACK_PARAM;
    return band.getAttribute('data-sbs-param') || FALLBACK_PARAM;
  }

  // Checkboxes nativos do filtro de tamanho, escopados na barra de filtros.
  function nativeSizeInputs(param) {
    return Array.prototype.slice.call(
      document.querySelectorAll(
        '[data-filter-bar] input[name="' + param + '"]'
      )
    );
  }

  function inputForValue(param, value) {
    var inputs = nativeSizeInputs(param);
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value === value) return inputs[i];
    }
    return null;
  }

  // Dispara o 'change' que o changeHandler do tema escuta (com bubbling).
  function fireChange(input) {
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function handleChip(band, chip, event) {
    // Chip desabilitado (0 produtos compraveis): ignora o clique.
    if (chip.classList.contains('is-disabled')) {
      event.preventDefault();
      return;
    }

    var value = chip.getAttribute('data-sbs-value');
    var input = inputForValue(paramFor(band), value);

    // Sem checkbox nativo => deixa o link nativo recarregar (fallback).
    if (!input) return;

    event.preventDefault();

    // Toggle multi-select, alinhado à semântica da gaveta FILTER.
    input.checked = !input.checked;

    // Feedback otimista; o re-render server-side de #root é a fonte da verdade.
    chip.classList.toggle('is-active', input.checked);

    fireChange(input);
  }

  function handleAll(band, all, event) {
    var inputs = nativeSizeInputs(paramFor(band));

    // Sem checkboxes nativos => deixa o link nativo recarregar (fallback).
    if (!inputs.length) return;

    event.preventDefault();

    var changed = false;
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].checked) {
        inputs[i].checked = false;
        changed = true;
      }
    }

    // Nada selecionado => já estamos em "ALL SIZES"; não há o que re-renderizar.
    if (!changed) return;

    fireChange(inputs[0]);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var band = target.closest('[data-shop-by-size]');
    if (!band) return;

    var chip = target.closest('[data-sbs-chip]');
    if (chip) {
      handleChip(band, chip, event);
      return;
    }

    var all = target.closest('[data-sbs-all]');
    if (all) {
      handleAll(band, all, event);
    }
  });
})();
